export const SUPPORT_EMAIL = "support@shansoai.com";

export function LegalPage({ eyebrow, title, intro, children, testId }) {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 md:py-24" data-testid={testId}>
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="mt-3 font-display text-3xl leading-tight tracking-tight sm:text-4xl">{title}</h1>
      {intro && <p className="mt-5 text-base leading-[1.8] text-foreground/75">{intro}</p>}
      <div className="mt-10 space-y-8 text-[15px] leading-[1.85] text-foreground/80">{children}</div>
      <p className="mt-14 border-t border-foreground/10 pt-6 text-sm text-muted-foreground">
        Questions? Write to <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-primary hover:underline">{SUPPORT_EMAIL}</a>.
      </p>
    </div>
  );
}

export const Clause = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-base font-semibold sm:text-lg">{heading}</h2>
    <div className="mt-2 space-y-3">{children}</div>
  </section>
);
